(function(){
var st=document.createElement('style');
st.textContent='@media(max-width:767px){.nx-lang{left:auto!important;right:14px!important;bottom:88px!important;transform:scale(.82);transform-origin:right bottom}}';
document.head.appendChild(st);
var USED={};function base(t){return t.split(/\s[–—-]\s/)[0].trim().toLowerCase()}
function first(t){return t.trim().split(/\s+/)[0].toLowerCase()}
function title(c){var a=c.querySelector('.x-card-title');return a?a.textContent.trim():''}
async function fix(id,coll){
var s=document.querySelector('[id$="__'+id+'"]');if(!s)return;
var cards=[].slice.call(s.querySelectorAll('.card-product'));if(!cards.length)return;
var pool=[];
for(var p=1;p<=3;p++){try{var h=await fetch('/collections/'+coll+'?page='+p).then(function(r){return r.text()});var d=new DOMParser().parseFromString(h,'text/html');var cs=[].slice.call(d.querySelectorAll('.card-product'));if(!cs.length)break;pool=pool.concat(cs)}catch(e){break}}
if(pool.length<cards.length)return;
var pick=[],fw={},bs=USED;
pool.forEach(function(c){var t=title(c);if(!t||/\sV-\s/.test(t))return;var f=first(t),b=base(t);if(!fw[f]&&!bs[b]&&pick.length<cards.length){fw[f]=1;bs[b]=1;pick.push(c)}});
pool.forEach(function(c){var t=title(c);if(!t||/\sV-\s/.test(t))return;var b=base(t);if(!bs[b]&&pick.length<cards.length){bs[b]=1;pick.push(c)}});
if(pick.length<cards.length)return;
cards.forEach(function(c,i){var n=document.importNode(pick[i],true);c.replaceWith(n);n.querySelectorAll('img').forEach(function(im){var u=im.getAttribute('src');im.removeAttribute('loading');im.src='';im.src=u})});
}
async function run(){await fix("bestsellers","bestsellery");await fix("new_in","nowosci")}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
